import {ConfigProvider} from 'providers/ConfigProvider'
import {EnvironmentProvider} from 'providers/EnvironmentProvider'
import {OrderDetailsProvider} from 'providers/OrderDetailsProvider'
import {OrderProvider} from 'providers/OrderProvider'
import {Queries} from 'providers/Queries'
import {Theme} from 'providers/Theme'
import {TimeoutProvider} from 'providers/TimeoutProvider'
import {Toaster} from 'providers/Toaster'
import {View} from './View'

export const Checkout = () => {
  return (
    <Toaster>
      <EnvironmentProvider>
        <Theme>
          <OrderDetailsProvider>
            <Queries>
              <OrderProvider>
                <TimeoutProvider showTimeoutScreen>
                  <ConfigProvider>
                    <View />
                  </ConfigProvider>
                </TimeoutProvider>
              </OrderProvider>
            </Queries>
          </OrderDetailsProvider>
        </Theme>
      </EnvironmentProvider>
    </Toaster>
  )
}
